module.exports = __webpack_public_path__ + "static/media/slider-icon.5b13d485.svg";